var map = {
	"./collection.js": "./src/config/features/collection.js",
	"./feature.js": "./src/config/features/feature.js",
	"./scope.js": "./src/config/features/scope.js",
	"./selector.js": "./src/config/features/selector.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 114;



//////////////////
// WEBPACK FOOTER
// ./src/config/features nonrecursive \.js$
// module id = 114
// module chunks = 0 1